module.exports = __webpack_public_path__ + "img/wangshang.5abcd9bd.png";